!(function () {
    "use strict";
    var e,
        t = {
            1092: function (e, t, i) {
                i.d(t, {
                    M: function () {
                        return a;
                    },
                });
                var s = i(6072),
                    n = i(1717);
                

                document.addEventListener("DOMContentLoaded", function () {
                    document.querySelectorAll(".icon").forEach((e) => {
                        e.classList.add("loaded");
                    }),
                    document.querySelectorAll('a[target="_blank"]').forEach((e) => {
                        e.innerHTML =
                            e.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>";
                    }),
                    (0, n.f)();
                }),
                    void 0 !== window.BOOMR &&
                        console.log(
                            "Built with " +
                                window.BOOMR.themeName +
                                " (https://themes.shopify.com/themes/align/) version " +
                                window.BOOMR.themeVersion +
                                " by Company XYZ (https://companyxyz.io/)."
                        ),
                    void 0 === window.Shopify && (window.Shopify = {}),
                    (Shopify.bind = function (e, t) {
                        return function () {
                            return e.apply(t, arguments);
                        };
                    }),
                    (Shopify.setSelectorByValue = function (e, t) {
                        for (var i = 0, s = e.options.length; i < s; i++) {
                            var n = e.options[i];
                            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
                        }
                    }),
                    (Shopify.addListener = function (e, t, i) {
                        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
                    }),
                    (Shopify.postLink = function (e, t) {
                        var i = (t = t || {}).method || "post",
                            s = t.parameters || {},
                            n = document.createElement("form");
                        for (var a in (n.setAttribute("method", i), n.setAttribute("action", e), s)) {
                            var r = document.createElement("input");
                            r.setAttribute("type", "hidden"),
                                r.setAttribute("name", a),
                                r.setAttribute("value", s[a]),
                                n.appendChild(r);
                        }
                        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
                    }),
                    (Shopify.CountryProvinceSelector = function (e, t, i) {
                        (this.countryEl = document.getElementById(e)),
                            (this.provinceEl = document.getElementById(t)),
                            (this.provinceContainer = document.getElementById(i.hideElement || t)),
                            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
                            this.initCountry(),
                            this.initProvince();
                    }),
                    (Shopify.CountryProvinceSelector.prototype = {
                        initCountry: function () {
                            var e = this.countryEl.getAttribute("data-default");
                            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
                        },
                        initProvince: function () {
                            var e = this.provinceEl.getAttribute("data-default");
                            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
                        },
                        countryHandler: function (e) {
                            var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
                                    "data-provinces"
                                ),
                                i = JSON.parse(t);
                            if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
                                this.provinceContainer.style.display = "none";
                            else {
                                for (var s = 0; s < i.length; s++) {
                                    var n;
                                    ((n = document.createElement("option")).value = i[s][0]),
                                        (n.innerHTML = i[s][1]),
                                        this.provinceEl.appendChild(n);
                                }
                                this.provinceContainer.style.display = "";
                            }
                        },
                        clearOptions: function (e) {
                            for (; e.firstChild; ) e.removeChild(e.firstChild);
                        },
                        setOptions: function (e, t) {
                            var i = 0;
                            for (t.length; i < t.length; i++) {
                                var s = document.createElement("option");
                                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
                            }
                        },
                    }),
                    document.querySelectorAll("video").forEach((e) => {
                        e.muted = !0;
                        let t = e.play();
                        void 0 !== t &&
                            t.then((t) => {
                                new IntersectionObserver(
                                    (t) => {
                                        t.forEach((t) => {
                                            t.isIntersecting
                                                ? 1 == e.autoplay && e.paused && e.play()
                                                : e.paused || e.pause();
                                        });
                                    },
                                    { threshold: 0 }
                                ).observe(e);
                            });
                    }),
                    document.querySelectorAll("video.hover-play").forEach((e) => {
                        const t = e.closest(".card");
                        e.pause(),
                            t
                                ? (t.addEventListener("mouseenter", () => {
                                      e.play();
                                  }),
                                  t.addEventListener("mouseleave", () => {
                                      e.pause();
                                  }))
                                : (e.addEventListener("mouseenter", () => {
                                      e.play();
                                  }),
                                  e.addEventListener("mouseleave", () => {
                                      e.pause();
                                  }));
                    });
                const a = function () {
                    [].slice.call(document.querySelectorAll("video")).forEach((e) => {
                        const t = e.parentElement.querySelector(".figure--video__poster");
                        t &&
                            t.addEventListener("click", () => {
                                t.classList.add("hidden"), e.play();
                            });
                    });
                    var e = [].slice.call(document.querySelectorAll(".figure--video-external"));
                    if ("IntersectionObserver" in window) {
                        var t = new IntersectionObserver(function (e, t) {
                            e.forEach(function (e) {
                                if (e.isIntersecting)
                                    "vimeo" == e.target.dataset.type &&
                                        fetch("http://vimeo.com/api/v2/video/" + e.target.dataset.id + ".json")
                                            .then((e) => {
                                                if (!e.ok) throw new Error(`HTTP error ${e.status}`);
                                                return e.json();
                                            })
                                            .then((t) => {
                                                e.target.querySelector(".figure--video__external-poster-image").src =
                                                    t[0].thumbnail_large;
                                            }),
                                        e.target.addEventListener("click", function () {
                                            if (!e.target.querySelector("iframe")) {
                                                let e = this.dataset.type,
                                                    t = document.createElement("iframe");
                                                t.setAttribute("frameborder", "0"),
                                                    t.setAttribute("allowfullscreen", ""),
                                                    t.setAttribute("allow", "autoplay"),
                                                    "youtube" == e
                                                        ? (t.setAttribute("id", "youtube"),
                                                          t.setAttribute(
                                                              "src",
                                                              "https://www.youtube.com/embed/" +
                                                                  this.dataset.id +
                                                                  this.dataset.videotags +
                                                                  "rel=0&showinfo=0&autoplay=1"
                                                          ))
                                                        : t.setAttribute(
                                                              "src",
                                                              "https://player.vimeo.com/video/" +
                                                                  this.dataset.id +
                                                                  this.dataset.videotags +
                                                                  "rel=0&showinfo=0&autoplay=1"
                                                          ),
                                                    this.appendChild(t),
                                                    setTimeout(() => {
                                                        this.querySelector(".figure--video__poster").classList.add(
                                                            "hidden"
                                                        );
                                                    }, 350);
                                            }
                                        });
                                else if (e.target.querySelector("iframe")) {
                                    let i = e.target.dataset.type,
                                        s = e.target.querySelectorAll("iframe");
                                    if ("youtube" == i) {
                                        var t = { event: "command", func: "pauseVideo" };
                                        s[0].contentWindow.postMessage(JSON.stringify(t), "*");
                                    } else
                                        "vimeo" == i &&
                                            ((t = { method: "pause", value: "true" }),
                                            s[0].contentWindow.postMessage(JSON.stringify(t), "*"));
                                }
                            });
                        });
                        e.forEach(function (e) {
                            t.observe(e);
                        });
                    }
                };
                a(),
                    window.addEventListener("beforeprint", () => {
                        const e = document.body.querySelectorAll("details"),
                            t = document.body.querySelectorAll("img");
                        for (let t = 0; t < e.length; t++)
                            e[t].open ? (e[t].dataset.open = "1") : e[t].setAttribute("open", "");
                        for (let e = 0; e < t.length; e++) t[e].dataset.open = "1";
                    }),
                    window.addEventListener("afterprint", () => {
                        const e = document.body.querySelectorAll("details");
                        for (let t = 0; t < e.length; t++)
                            e[t].dataset.open ? (e[t].dataset.open = "") : e[t].removeAttribute("open");
                    }),
                    Shopify.designMode &&
                        document.addEventListener("shopify:section:load", () => {
                            a(),
                                document.querySelectorAll(".icon").forEach((e) => {
                                    e.classList.add("loaded");
                                });
                        });
                class r extends HTMLElement {
                    constructor() {
                        super(),
                            this.addEventListener("change", this.onVariantChange),
                            (this.isCardBasedProductForm = null !== this.closest(".card__content"));
                    }
                    connectedCallback() {
                        (this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product),
                            (this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product);
                    }
                    onVariantChange() {
                        this.updateOptions(),
                            this.updateMasterId(),
                            this.currentVariant
                                ? (this.updateVariantStatuses(),
                                  this.updateImageSwatches(),
                                  this.updateMedia(),
                                  this.updateURL(),
                                  this.updateLinks(),
                                  this.renderProductInfo(),
                                  this.updateVariantInput(),
                                  this.updateAddToCart())
                                : void 0 === this.currentVariant && this.setUnavailable();
                    }
                    updateOptions() {
                        this.options = Array.from(this.querySelectorAll("select, fieldset"), (e) => {
                            return "SELECT" === e.tagName
                                ? e.value
                                : "FIELDSET" === e.tagName
                                  ? null === (t = Array.from(e.querySelectorAll("input")).find((e) => e.checked)) ||
                                    void 0 === t
                                      ? void 0
                                      : t.value
                                  : void 0;
                            var t;
                        });
                    }
                    updateMasterId() {
                        this.options.includes(void 0)
                            ? (this.currentVariant = null)
                            : (this.currentVariant = this.getVariantData().find(
                                  (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
                              ));
                    }
                    updateVariantStatuses() {
                        const e = this.querySelector(":checked").value,
                            t = this.getVariantData().filter((t) => t.options[0] === e);
                        this.getProductVariantSelects().forEach((e) => {
                            const i = e.querySelectorAll("select, fieldset");
                            i.forEach((e, s) => {
                                if (0 === s) return;
                                const n = e.querySelectorAll('input[type="radio"], option'),
                                    a = i[s - 1].querySelector(":checked").value,
                                    r = t
                                        .filter((e) => e.available && e[`option${s}`] === a)
                                        .map((e) => e[`option${s + 1}`]);
                                this.setInputAvailability(n, r);
                            });
                        });
                    }
                    setInputAvailability(e, t) {
                        e.forEach((e) => {
                            const i = e.getAttribute("value"),
                                s = t.includes(i);
                            "OPTION" === e.tagName &&
                                (e.innerText = s
                                    ? i
                                    : window.productStrings.unavailable_with_option.replace("[value]", i));
                        });
                    }
                    updateImageSwatches() {
                        this.querySelectorAll("fieldset:has(.image-swatch)").forEach((e) => {
                            const t = e.dataset.optionPosition,
                                i = e.querySelectorAll(".image-swatch");
                            for (const e of i) {
                                const i = [...this.options];
                                i[t - 1] = e.value;
                                const s = this.getVariantData().find(
                                    (e) => e.options[0] == i[0] && e.options[1] == i[1] && e.options[2] == i[2]
                                );
                                if (!s) continue;
                                const n = e.labels[0],
                                    a = n.querySelectorAll("img.variant-image"),
                                    r = n.querySelector(`img[data-variant-id="${s.id}"]`),
                                    o = n.querySelector(".image_swatch--text_value");
                                a.forEach((e) => {
                                    e.classList.add("hidden");
                                }),
                                    o.classList.add("u-hide"),
                                    r ? r.classList.remove("hidden") : o.classList.remove("u-hide");
                            }
                        });
                    }
                    updateMedia() {
                        if (!this.currentVariant) return;
                        if (!this.currentVariant.featured_media) return;
                        const e = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
                            t = e.dataset.variantStyle;
                        if (this.currentVariant.featured_media) {
                            const i = this.currentVariant.featured_media.id;
                            if ("default" == t)
                                if (e.swiper) {
                                    const t = e.swiper.slides,
                                        s = Array.from(t).findIndex((e) => e.dataset.id == i);
                                    -1 !== s && e.swiper.slideToLoop(s);
                                } else {
                                    const t = e.querySelector(".swiper-wrapper"),
                                        s = t.querySelector(`[data-id="${i}"]`);
                                    s && t.prepend(s);
                                }
                            else if ("variant" == t) {
                                const t = e.querySelector(".swiper-wrapper"),
                                    s = t.querySelector(`[data-id="${i}"]`);
                                s && (t.firstChild.classList.add("u-hide"), s.classList.remove("u-hide"), t.prepend(s));
                            }
                            const s = document.querySelectorAll(".sticky-add-to-cart__image"),
                                n = this.currentVariant.id;
                            s.forEach((e) => {
                                e.dataset.variantId == n ? e.classList.remove("u-hide") : e.classList.add("u-hide");
                            });
                        }
                    }
                    updateURL() {
                        if ("false" === this.dataset.updateUrl) return;
                        const e = `${this.dataset.url}?variant=${this.currentVariant.id}`;
                        window.history.replaceState({}, "", e);
                    }
                    updateLinks() {
                        if (!this.isCardBasedProductForm) return;
                        const e = this.closest(".card__content").querySelector(".button--view-product");
                        "A" === (null == e ? void 0 : e.tagName) &&
                            (e.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`);
                    }
                    updateVariantInput() {
                        document
                            .querySelectorAll(
                                `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
                            )
                            .forEach((e) => {
                                const t = e.querySelector('input[name="id"]');
                                (t.value = this.currentVariant.id),
                                    t.dispatchEvent(new Event("change", { bubbles: !0 }));
                            });
                        const e = this.getProductVariantSelects();
                        e.length > 1 && this.syncSelectValues(e);
                    }
                    syncSelectValues(e) {
                        e.forEach((e) => {
                            e.querySelectorAll("select, fieldset").forEach((e) => {
                                if ("SELECT" === e.tagName)
                                    this.currentVariant.options[e.dataset.optionPosition - 1] &&
                                        (e.value = this.currentVariant.options[e.dataset.optionPosition - 1]);
                                else if ("FIELDSET" === e.tagName) {
                                    const t = Array.from(e.querySelectorAll("input")).find(
                                        (t) => t.value === this.currentVariant.options[e.dataset.optionPosition - 1]
                                    );
                                    t && (t.checked = !0);
                                }
                            });
                        });
                    }
                    renderProductInfo() {
                        var e;
                        const t = document.getElementById(`price-${this.uniqueIdentifier}`);
                        t &&
                            (t.classList.contains("price--on-sale")
                                ? t
                                      .querySelectorAll(".price__sale .price-item")
                                      .forEach((e) => e.classList.add("skeleton-loading"))
                                : t.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const i = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        i &&
                            (i.classList.contains("price--on-sale")
                                ? i
                                      .querySelectorAll(".price__sale .price-item")
                                      .forEach((e) => e.classList.add("skeleton-loading"))
                                : i.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const n = document.getElementById(`pickup-availability-${this.uniqueIdentifier}`);
                        null == n ||
                            null === (e = n.querySelector(".skeleton-loading-wrapper")) ||
                            void 0 === e ||
                            e.classList.add("skeleton-loading");
                        const a = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        null == a || a.classList.add("skeleton-loading");
                        const r = document.getElementById(`pickup-availability-modal-${this.uniqueIdentifier}`);
                        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
                            .then((e) => e.text())
                            .then((e) => {
                                const o = new DOMParser().parseFromString(e, "text/html"),
                                    l = o.getElementById(`price-${this.mainProductUniqueIdentifier}`);
                                if (a) {
                                    const e = o.getElementById(`stock-status-${this.mainProductUniqueIdentifier}`);
                                    e
                                        ? (a.classList.remove("u-invisible"),
                                          (a.innerHTML = e.innerHTML),
                                          (a.classList = e.classList))
                                        : null == a || a.classList.add("u-invisible");
                                }
                                if (
                                    (l && t
                                        ? (t.classList.remove("u-invisible"),
                                          (t.innerHTML = l.innerHTML),
                                          (t.classList = l.classList))
                                        : null == t || t.classList.add("u-invisible"),
                                    i)
                                ) {
                                    const e = o.getElementById(`sticky-price-${this.mainProductUniqueIdentifier}`);
                                    e
                                        ? (i.classList.remove("u-invisible"),
                                          (i.innerHTML = e.innerHTML),
                                          (i.classList = e.classList))
                                        : null == i || i.classList.add("u-invisible");
                                }
                                if (n) {
                                    const e = o.getElementById(
                                        `pickup-availability-${this.mainProductUniqueIdentifier}`
                                    );
                                    e && ((n.innerHTML = e.innerHTML), (n.classList = e.classList));
                                }
                                if (r) {
                                    const e = o.getElementById(
                                        `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
                                    );
                                    e && (r.innerHTML = e.innerHTML);
                                }
                                const d = document.querySelector(".pickup-availability"),
                                    c = document.getElementById("overlay"),
                                    u = document.getElementById("pickup-availability-open"),
                                    h = document.getElementById("pickup-availability-close");
                                u &&
                                    document
                                        .getElementById("pickup-availability-open")
                                        .addEventListener("click", function () {
                                            d.classList.add("open"),
                                                c.classList.add("open"),
                                                document.body.classList.add("active", "minicart"),
                                                (0, s.hO)(!0);
                                        }),
                                    h &&
                                        document
                                            .getElementById("pickup-availability-close")
                                            .addEventListener("click", function () {
                                                d.classList.remove("open"),
                                                    document.body.classList.remove("active", "minicart"),
                                                    (0, s.hO)(!1),
                                                    overlay.classList.remove("open", "overlay--all"),
                                                    (0, s.zx)(d);
                                            });
                            });
                    }
                    updateAddToCart() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
                        e &&
                            (this.currentVariant.available
                                ? e.forEach((e) => {
                                      const t = e.querySelector('[name="add"]'),
                                          i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                                      t &&
                                          (t.removeAttribute("disabled"), (i.textContent = `${cartStrings.addToCart}`));
                                  })
                                : e.forEach((e) => {
                                      const t = e.querySelector('[name="add"]'),
                                          i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                                      t &&
                                          (t.setAttribute("disabled", "disabled"),
                                          (i.textContent = `${cartStrings.soldOut}`));
                                  }));
                    }
                    setUnavailable() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`),
                            t = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        e.forEach((e) => {
                            const i = e.querySelector('[name="add"]'),
                                s = e.querySelector('[name="add"] > span:not(.cart-icon)');
                            i &&
                                ((s.textContent = `${cartStrings.unavailable}`),
                                i.setAttribute("disabled", "disabled"),
                                t && (t.dataset.state = "unavailable"));
                        });
                        const i = document.getElementById(`price-${this.uniqueIdentifier}`),
                            s = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        i && this.setPriceUnavailable(i), s && this.setPriceUnavailable(s);
                    }
                    setPriceUnavailable(e) {
                        e.classList.remove("price--on-sale"),
                            e.classList.add("price--sold-out"),
                            (e.querySelector(".price__regular .price-item.price-item--regular").textContent =
                                window.productStrings.price_unavailable);
                    }
                    getVariantData() {
                        return (
                            (this.variantData =
                                this.variantData ||
                                JSON.parse(this.querySelector('[type="application/json"]').textContent)),
                            this.variantData
                        );
                    }
                    getProductVariantSelects() {
                        return document.querySelectorAll(
                            `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"]`
                        );
                    }
                }
                customElements.get("variant-selects") || customElements.define("variant-selects", r);
                class o {
                    constructor(e) {
                        (this.el = e),
                            (this.summary = e.querySelector("summary")),
                            (this.content = e.querySelector(".content")),
                            (this.animation = null),
                            (this.isClosing = !1),
                            (this.isExpanding = !1),
                            this.summary.addEventListener("click", (e) => this.onClick(e));
                    }
                    onClick(e) {
                        e.preventDefault(),
                            (this.el.style.overflow = "hidden"),
                            this.isClosing || !this.el.open
                                ? this.open()
                                : (this.isExpanding || this.el.open) && this.shrink();
                    }
                    shrink() {
                        this.isClosing = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate(
                                { height: [e, t] },
                                { duration: 400, easing: "ease-out" }
                            )),
                            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
                            (this.animation.oncancel = () => (this.isClosing = !1));
                    }
                    open() {
                        (this.el.style.height = `${this.el.offsetHeight}px`),
                            (this.el.open = !0),
                            window.requestAnimationFrame(() => this.expand());
                    }
                    expand() {
                        this.isExpanding = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate(
                                { height: [e, t] },
                                { duration: 400, easing: "ease-out" }
                            )),
                            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
                            (this.animation.oncancel = () => (this.isExpanding = !1));
                    }
                    onAnimationFinish(e) {
                        (this.el.open = e),
                            (this.animation = null),
                            (this.isClosing = !1),
                            (this.isExpanding = !1),
                            (this.el.style.height = this.el.style.overflow = "");
                    }
                }
                document.querySelectorAll("details.accordion__wrapper").forEach((e) => {
                    new o(e);
                });
            },
            4489: function domaction(e, t, i) {
                var s = i(6072);
                var observer = new MutationObserver(onDomUpdated)
                observer.observe(document.querySelector("#mini-cart"), {
                    childList: true,
                    subtree: true
                });
                function onDomUpdated(mutations) {
                    document.querySelectorAll(".icon").forEach((e) => {
                        e.classList.add("loaded")
                    });
                
                const n = new (class {
                    constructor() {
                        (this.items = Array.from(document.querySelector('.mini-cart__sidebar').querySelectorAll(".cart-item"))),
                            this.items.forEach((e) => this.manageState(e)),
                            (this.selectorsToUpdate = [
                                ".cart-summary__header",
                                "#cart-total-price",
                                "#checkout",
                                ".cart-summary__free-shipping",
                            ]),
                            (this.mainCartSelector = ".shopify-section.cart"),
                            (this.miniCart = document.getElementById("mini-cart")),
                            (this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty"),
                            (this.parser = new DOMParser());
                    }
                    manageState(e) {
                        // const drawer_items = document.querySelectorAll(".drawer_cart_items");
                        // drawer_items.forEach((index) => {
                        //     drawer_items.setAttribute('data-variant-id',index);
                        // });
                        document.querySelectorAll('.drawer_cart_items').forEach((el, index) => {
                            el.setAttribute('data-variant-id', index+1);
                        });
                        const t = e.getAttribute("data-variant-id");
                        e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () => {
                            await this.changeCartItem({ id: t, quantity: 0 }), console.log(t), e.remove();
                        });
                        const i = e.querySelector('input[name="quantity"]');
                        if (!i) return;
                        const s = e.querySelector('button[name="plus"]'),
                            n = e.querySelector('button[name="minus"]');
                            // a = e.querySelector('input[name="quantity"]');
                        let r = parseInt(i.value);
                        s.addEventListener("click", () => {
                            (r += 1), (i.value = r), this.changeCartItem({ id: t, quantity: r });
                        }),
                        n.addEventListener("click", () => {
                            (r -= 1), (i.value = r), this.changeCartItem({ id: t, quantity: r });
                        });
                        // a.addEventListener("change", (e) => {
                        //     parseInt(e.target.value) > 0
                        //         ? ((r = parseInt(e.target.value)), this.changeCartItem({ id: t, quantity: r }))
                        //         : (a.value = r);
                        // }),
                        // a.addEventListener("keypress", (e) => {
                        //     ((8 !== e.which && 0 !== e.which && e.which < 48) || e.which > 57) &&
                        //         e.preventDefault();
                        // });
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, s.Q2)(),
                            body: JSON.stringify({ line: +e.id, quantity: e.quantity, sections: "main-cart" }),
                        };
                        fetch(`${routes.cartChange}`, t)
                            .then((e) => e.json())
                            .then((e) => {
                                const t = (t) => {
                                    const i = this.parser.parseFromString(t, "text/html");
                                    if (0 === e.item_count) {
                                        const e = document.querySelector(this.mainCartSelector);
                                        e && (e.innerHTML = i.querySelector(this.mainCartSelector).innerHTML),
                                            this.renderElements(i);
                                    } else this.renderItems(i);
                                };
                                if (e.sections && null !== e.sections["main-cart"]) t(e.sections["main-cart"]);
                                else {
                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((e) => {
                                            t(e);
                                        });
                                }
                                const i = `${window.location.pathname}?section_id=navigation-main`;
                                fetch(i)
                                    .then((e) => e.text())
                                    .then((t) => {
                                        const i = this.parser.parseFromString(t, "text/html");
                                        if (0 === e.item_count) {
                                            const e = document.querySelector("#mini-cart");
                                            e &&
                                                ((e.innerHTML = i.querySelector("#mini-cart").innerHTML),
                                                e.addEventListeners(),
                                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")));
                                        }
                                    });
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t) => {
                            try {
                                const i = document.querySelectorAll(t),
                                    s = e.querySelector(t);
                                i.length &&
                                    s &&
                                    i.forEach((e) => {
                                        s.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                            e.replaceWith(s.cloneNode(!0));
                                    });
                            } catch (e) {
                                console.error(`Error updating ${t}`, e);
                            }
                        });
                        const t = e.querySelector(".cart-count");
                        document
                            .querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count")
                            .forEach((e) => {
                                t
                                    ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"),
                                      (e.textContent = t.textContent))
                                    : e.classList.add("visually-hidden");
                            }),
                            //console.log(t.textContent),
                            document.querySelector("#cart-open-block .icon").classList.add("loaded");
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            i = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e) => {
                            e && e.replaceWith(i.cloneNode(!0));
                        }),
                            document.querySelectorAll(".cart-item").forEach((e) => {
                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded"));
                                    //this.manageState(e);
                            });
                    }
                    updateMiniCart(e) {
                        return fetch("/?section_id=main-cart")
                            .then((e) => e.text())
                            .then((t) => {
                                this.renderItems(new DOMParser().parseFromString(t, "text/html")),
                                    e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open();
                            })
                            .catch((e) => {
                                console.error("Error updating mini cart:", e);
                            });
                    }
                })();
                };
                
                (t.Z = n),
                    customElements.get("cart-note") ||
                        customElements.define(
                            "cart-note",
                            class extends HTMLElement {
                                constructor() {
                                    super(),
                                        this.querySelector("textarea").addEventListener(
                                            "change",
                                            (0, s.Ds)((e) => {
                                                const t = JSON.stringify({ note: e.target.value });
                                                fetch(`${routes.cartUpdate}`, { ...(0, s.Q2)(), body: t });
                                            }, 300)
                                        );
                                }
                            }
                        );
            },
            4487: function (e, t, i) {
                var s = i(6072);
                
                const n = new (class {
                    constructor() {
                        (this.items = Array.from(document.querySelectorAll(".cart-item"))),
                            this.items.forEach((e) => this.manageState(e)),
                            (this.selectorsToUpdate = [
                                ".cart-summary__header",
                                "#cart-total-price",
                                "#checkout",
                                ".cart-summary__free-shipping",
                            ]),
                            (this.mainCartSelector = ".shopify-section.cart"),
                            (this.miniCart = document.getElementById("mini-cart")),
                            (this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty"),
                            (this.parser = new DOMParser());
                    }
                    manageState(e) {
                        const t = e.getAttribute("data-variant-id");
                        e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () => {
                            await this.changeCartItem({ id: t, quantity: 0 }), e.remove();
                        });
                        const i = e.querySelector('input[name="quantity"]');
                        if (!i) return;
                        const s = e.querySelector('button[name="plus"]'),
                            n = e.querySelector('button[name="minus"]'),
                            a = e.querySelector('input[name="quantity"]');
                        let r = parseInt(i.value);
                        s.addEventListener("click", () => {
                            (r += 1), (i.value = r), this.changeCartItem({ id: t, quantity: r });
                        }),
                        n.addEventListener("click", () => {
                            (r -= 1), (i.value = r), this.changeCartItem({ id: t, quantity: r });
                        }),
                        a.addEventListener("change", (e) => {
                            parseInt(e.target.value) > 0
                                ? ((r = parseInt(e.target.value)), this.changeCartItem({ id: t, quantity: r }))
                                : (a.value = r);
                        }),
                        a.addEventListener("keypress", (e) => {
                            ((8 !== e.which && 0 !== e.which && e.which < 48) || e.which > 57) &&
                                e.preventDefault();
                        });
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, s.Q2)(),
                            body: JSON.stringify({ line: +e.id, quantity: e.quantity, sections: "main-cart" }),
                        };
                        fetch(`${routes.cartChange}`, t)
                            .then((e) => e.json())
                            .then((e) => {
                                const t = (t) => {
                                    const i = this.parser.parseFromString(t, "text/html");
                                    if (0 === e.item_count) {
                                        const e = document.querySelector(this.mainCartSelector);
                                        e && (e.innerHTML = i.querySelector(this.mainCartSelector).innerHTML),
                                            this.renderElements(i);
                                    } else this.renderItems(i);
                                };
                                if (e.sections && null !== e.sections["main-cart"]) t(e.sections["main-cart"]);
                                else {
                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((e) => {
                                            t(e);
                                        });
                                }
                                const i = `${window.location.pathname}?section_id=navigation-main`;
                                fetch(i)
                                    .then((e) => e.text())
                                    .then((t) => {
                                        const i = this.parser.parseFromString(t, "text/html");
                                        if (0 === e.item_count) {
                                            const e = document.querySelector("#mini-cart");
                                            e &&
                                                ((e.innerHTML = i.querySelector("#mini-cart").innerHTML),
                                                e.addEventListeners(),
                                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")));
                                        }
                                    });
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t) => {
                            try {
                                const i = document.querySelectorAll(t),
                                    s = e.querySelector(t);
                                i.length &&
                                    s &&
                                    i.forEach((e) => {
                                        s.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                            e.replaceWith(s.cloneNode(!0));
                                    });
                            } catch (e) {
                                console.error(`Error updating ${t}`, e);
                            }
                        });
                        const t = e.querySelector(".cart-count");
                        document
                            .querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count")
                            .forEach((e) => {
                                t
                                    ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"),
                                      (e.textContent = t.textContent))
                                    : e.classList.add("visually-hidden");
                            }),
                            //console.log(t.textContent),
                            document.querySelector("#cart-open-block .icon").classList.add("loaded");
                            
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            i = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e) => {
                            e && e.replaceWith(i.cloneNode(!0));
                        }),
                            document.querySelectorAll(".cart-item").forEach((e) => {
                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded"));
                                    // this.manageState(e);
                            });
                    }
                    updateMiniCart(e) {
                        return fetch("/?section_id=main-cart")
                            .then((e) => e.text())
                            .then((t) => {
                                this.renderItems(new DOMParser().parseFromString(t, "text/html")),
                                    e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open();
                            })
                            .catch((e) => {
                                console.error("Error updating mini cart:", e);
                            });
                    }
                })();
                
                (t.Z = n),
                    customElements.get("cart-note") ||
                        customElements.define(
                            "cart-note",
                            class extends HTMLElement {
                                constructor() {
                                    super(),
                                        this.querySelector("textarea").addEventListener(
                                            "change",
                                            (0, s.Ds)((e) => {
                                                const t = JSON.stringify({ note: e.target.value });
                                                fetch(`${routes.cartUpdate}`, { ...(0, s.Q2)(), body: t });
                                            }, 300)
                                        );
                                }
                            }
                        );
            },
            1717: function (e, t, i) {
                i.d(t, {
                    f: function () {
                        return a;
                    },
                });
                var s = i(6072),
                    n = i(4487),
                    v = i(4489);
                const a = () => {
                    const e = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
                        t = document.getElementById("main-cart"),
                        i = document.getElementById("mini-cart"),
                        a = document.querySelector("body");
                    e.length &&
                        e.forEach((e) =>
                            e.addEventListener("submit", (r) => {
                                r.preventDefault(),
                                    r.stopPropagation(),
                                    r.target.querySelector(
                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                    ) &&
                                        (r.target.querySelector(
                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                        ).textContent = `${cartStrings.addingToCart}`);
                                const o = r.target.querySelector('button[type="submit"]'),
                                    l = o.querySelector("span.cart-icon"),
                                    d = o.querySelector("svg.loading-icon");
                                a.classList.remove("added-to-cart"),
                                    o.classList.add("added"),
                                    (l.style.display = "none"),
                                    (d.style.display = "block");
                                const c = (0, s.Q2)("javascript");
                                (c.headers["X-Requested-With"] = "XMLHttpRequest"), delete c.headers["Content-Type"];
                                const u = new FormData(e);
                                u.append("sections", "main-cart"),
                                    (c.body = u),
                                    fetch(`${routes.cartAdd}`, c)
                                        .then((e) => e.json())
                                        .then(async (e) => {
                                            if (e.status) {
                                                if (
                                                    (n.Z.updateMiniCart(!0),
                                                    (l.style.display = "inline-flex"),
                                                    (d.style.display = "none"),
                                                    r.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (r.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addToCart}`),
                                                    "object" == typeof e.description)
                                                )
                                                    return Object.entries(e.description).forEach((e) => {
                                                        let [t, i] = e;
                                                        const s = `${i.join(", ")}`;
                                                        r.target.querySelector(".main-product__error").innerHTML =
                                                            '<span class="icon loaded">error</span><p>' + s + "</p>";
                                                    });
                                                r.target.querySelector(".main-product__error").innerHTML =
                                                    '<span class="icon loaded">error</span><p>' +
                                                    e.description +
                                                    "</p>";
                                            } else {
                                                if ("cart" === cartStrings.uxCart)
                                                    return void (window.location.href = window.routes.cart);
                                                if (
                                                    ((r.target.querySelector(".main-product__error").innerHTML = ""),
                                                    t && t.classList.add("added"),
                                                    e.sections && null !== e.sections["main-cart"])
                                                )
                                                    n.Z.renderItems(
                                                        new DOMParser().parseFromString(
                                                            e.sections["main-cart"],
                                                            "text/html"
                                                        )
                                                    );
                                                else {
                                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                                    fetch(e)
                                                        .then((e) => e.text())
                                                        .then((e) => {
                                                            n.Z.renderItems(
                                                                new DOMParser().parseFromString(e, "text/html")
                                                            );
                                                        });
                                                }
                                                "mini-cart" === cartStrings.uxCart && i && i.open(),
                                                    r.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (r.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addedToCart}`),
                                                    o.classList.remove("added"),
                                                    o.classList.add("successful"),
                                                    (l.style.display = "flex"),
                                                    (d.style.display = "none"),
                                                    a.classList.add("added-to-cart");
                                            }
                                        })
                                        .catch((e) => {
                                            console.error("Error:", e);
                                        });
                            })
                        );
                };
            },
            6999: function (e, t, i) {
                var s = i(8592),
                    n = i(5560),
                    a = i(1092);
                class r extends HTMLElement {
                    constructor() {
                        super(),
                            (this.mobile = window.matchMedia("(min-width: 0px) and (max-width: 767px)")),
                            (this.desktop = window.matchMedia("(min-width: 768px)"));
                        const e = this.querySelectorAll(".swiper-slide");
                        if (!e || (1 === e.length && "false" === this.getAttribute("data-loop"))) return;
                        if (((this.parentContainer = this.closest(".slider")), !this.parentContainer)) return;
                        (this.parentContainerID = this.parentContainer.id),
                            (this.mobileLayout = this.getAttribute("data-mobile-layout")),
                            (this.desktopLayout = this.getAttribute("data-desktop-layout")),
                            (this.videos = this.parentContainer.querySelectorAll("video")),
                            (this.mobileSlidesPerView =
                                "auto" === this.getAttribute("data-mobile-slides-per-view")
                                    ? "auto"
                                    : Number(this.getAttribute("data-mobile-slides-per-view")) || 1),
                            (this.desktopSlidesPerView =
                                "auto" === this.getAttribute("data-desktop-slides-per-view")
                                    ? "auto"
                                    : Number(this.getAttribute("data-desktop-slides-per-view")) || 1),
                            (this.tabletSlidesPerView =
                                "auto" === this.getAttribute("data-tablet-slides-per-view")
                                    ? "auto"
                                    : Number(this.getAttribute("data-tablet-slides-per-view")) ||
                                      this.desktopSlidesPerView);
                        const t = "true" === this.getAttribute("data-display-navigation") || !0,
                            i = this.getAttribute("data-pagination-type") || "bullets";
                        (this.animationStyle = this.getAttribute("data-animation-style") || "slide"),
                            "fade" === this.animationStyle &&
                                ((this.mobileSlidesPerView = 1),
                                (this.tabletSlidesPerView = 1),
                                (this.desktopSlidesPerView = 1)),
                            (this.autoplay = "true" === this.getAttribute("data-autoplay") || !1),
                            (this.autoplayDelay = Number(this.getAttribute("data-autoplay-delay"))),
                            (this.autoplayParams = !!this.autoplay && {
                                delay: this.autoplayDelay,
                                pauseOnMouseEnter: !0,
                            }),
                            (this.autoheight =
                                !this.hasAttribute("data-autoheight") ||
                                "true" === this.getAttribute("data-autoheight")),
                            (this.nested = "true" === this.getAttribute("data-nested") || !1),
                            (this.loop = "true" === this.getAttribute("data-loop") || !1),
                            (this.grabCursor =
                                !this.getAttribute("data-grab") || "true" === this.getAttribute("data-grab")),
                            (this.transitionSpeed = this.getAttribute("data-transition-speed") || 300),
                            (this.hasTextPagination = this.hasAttribute("data-text-pagination")),
                            this.hasTextPagination &&
                                ((this.desktopSlidesPerView = "auto"),
                                (this.tabletSlidesPerView = "auto"),
                                (this.mobileSlidesPerView = 1),
                                (this.desktopSlidesPerGroup = 1),
                                (this.tabletSlidesPerGroup = 1),
                                (this.mobileSlidesPerGroup = 1));
                        const s = this.getAttribute("data-space-between");
                        if (
                            ((this.spaceBetweenSlidesMobile =
                                s ?? (this.getAttribute("data-space-between-mobile") || 16)),
                            (this.spaceBetweenSlidesDesktop =
                                s ?? (this.getAttribute("data-space-between-desktop") || 32)),
                            (this.spaceBetweenSlidesTablet =
                                s ??
                                (this.getAttribute("data-space-between-tablet") || this.spaceBetweenSlidesDesktop)),
                            (this.paginationParams = !1),
                            (this.scrollbarParams = !1),
                            "scrollbar" === i)
                        ) {
                            const e = this.parentContainer.querySelector(".swiper-scrollbar");
                            this.scrollbarParams = { el: e, hide: !1, draggable: !0 };
                        } else {
                            let e = ".swiper-pagination";
                            this.parentContainerID && (e += `#${this.parentContainerID}`);
                            const t = this.parentContainer.querySelector(e),
                                s = "bullets" === i,
                                n = "true" === this.getAttribute("data-bullets-dynamic");
                            this.paginationParams = { el: t, clickable: s, dynamicBullets: n, type: i };
                        }
                        if (t) {
                            let e = ".swiper-button-prev",
                                t = ".swiper-button-next";
                            this.parentContainerID &&
                                ((e += `#${this.parentContainerID}`), (t += `#${this.parentContainerID}`));
                            const i = this.parentContainer.querySelector(e),
                                s = this.parentContainer.querySelector(t);
                            this.navigationParams = { prevEl: i, nextEl: s };
                        } else this.navigationParams = { enabled: !1 };
                        "fade" === this.animationStyle
                            ? ((this.mobileSlidesPerGroup = 1),
                              (this.desktopSlidesPerGroup = 1),
                              (this.tabletSlidesPerGroup = 1))
                            : ((this.mobileSlidesPerGroup = Math.floor(this.mobileSlidesPerView) || 1),
                              (this.desktopSlidesPerGroup = Math.floor(this.desktopSlidesPerView) || 1),
                              (this.tabletSlidesPerGroup =
                                  Math.floor(this.tabletSlidesPerView) || this.desktopSlidesPerGroup)),
                            (this.allSlides = Array.from(this.querySelectorAll(".swiper-slide"))),
                            (this.updateSlideVisibility = this.updateSlideVisibility.bind(this)),
                            (this.handleSliderDisplayLogic = this.handleSliderDisplayLogic.bind(this)),
                            (this.slideCount = e.length),
                            (this.checkSlidesPerView = this.checkSlidesPerView.bind(this)),
                            (this.playVisibleSlideVideos = this.playVisibleSlideVideos.bind(this));
                    }
                    connectedCallback() {
                        this.handleSliderDisplayLogic(),
                            this.updateSlideVisibility(),
                            window.addEventListener("resize", this.handleSliderDisplayLogic.bind(this)),
                            window.addEventListener("resize", this.updateSlideVisibility.bind(this)),
                            window.addEventListener("resize", this.checkSlidesPerView.bind(this)),
                            Shopify.designMode &&
                                (document.addEventListener(
                                    "shopify:section:load",
                                    this.handleSliderDisplayLogic.bind(this)
                                ),
                                document.addEventListener(
                                    "shopify:section:load",
                                    this.updateSlideVisibility.bind(this)
                                ),
                                document.addEventListener("shopify:section:load", this.checkSlidesPerView.bind(this)));
                    }
                    updateSlideVisibility() {
                        this.swiper &&
                            (this.hasTextPagination ? this.rebuildSlides() : this.updateSlideVisibilitySimple(),
                            this.swiper.update());
                    }
                    rebuildSlides() {
                        this.swiper.removeAllSlides(),
                            this.allSlides.forEach((e) => {
                                (this.desktop.matches && e.classList.contains("hide-desktop")) ||
                                    (this.mobile.matches && e.classList.contains("hide-mobile")) ||
                                    this.swiper.appendSlide(e);
                            }),
                            this.updateTextPagination();
                    }
                    updateSlideVisibilitySimple() {
                        this.swiper.slides.forEach((e) => {
                            const t =
                                (this.desktop.matches && e.classList.contains("hide-desktop")) ||
                                (this.mobile.matches && e.classList.contains("hide-mobile"));
                            e.style.display = t ? "none" : "";
                        });
                    }
                    updateTextPagination() {
                        this.parentContainer.querySelectorAll(".slideshow-text-controls__item").forEach((e) => {
                            const t =
                                (this.desktop.matches && e.classList.contains("hide-desktop")) ||
                                (this.mobile.matches && e.classList.contains("hide-mobile"));
                            e.style.display = t ? "none" : "";
                        }),
                            this.updateActiveTextItem();
                    }
                    updateActiveTextItem() {
                        if (!this.swiper || !this.swiper.slides || 0 === this.swiper.slides.length) return;
                        const e = this.swiper.slides[this.swiper.realIndex];
                        if (!e) return;
                        const t = e.getAttribute("data-slide");
                        this.parentContainer.querySelectorAll(".slideshow-text-controls__item").forEach((e) => {
                            e.classList.remove("active"),
                                e.getAttribute("data-slide") === t &&
                                    "none" !== e.style.display &&
                                    e.classList.add("active");
                        });
                    }
                    handleSliderDisplayLogic() {
                        const e = this.getSlidesPerView(this.getCurrentBreakpoint());
                        this.sliderShouldBeBuilt() && ("auto" === e || this.slideCount > e)
                            ? this.swiper
                                ? this.swiper.update()
                                : (this.enableSwiper(),
                                  this.parentContainer.classList.add("slider-enabled"),
                                  this.classList.remove("swiper-prevent-content-shift"))
                            : this.destroySwiper();
                    }
                    sliderShouldBeBuilt() {
                        return (
                            (this.desktop.matches && "slider" === this.desktopLayout) ||
                            (this.mobile.matches && "slider" === this.mobileLayout)
                        );
                    }
                    pauseAllVideos() {
                        Array.prototype.forEach.call(this.videos, (e) => {
                            e.classList.contains("section__wrapper-background") || e.pause();
                        });
                    }
                    playVisibleSlideVideos() {
                        this.pauseAllVideos();
                        const e = this.parentContainer.getElementsByClassName("swiper-slide-fully-visible");
                        Array.from(e).forEach((e) => {
                            const t = e.getElementsByTagName("video")[0];
                            t && t.hasAttribute("autoplay") && t.play();
                        });
                    }
                    enableSwiper() {
                        if (
                            ((this.swiper = new s.Z(this, {
                                modules: [n.W_, n.tl, n.LW, n.s5, n.xW, n.pt, n.bi],
                                effect: this.animationStyle,
                                fadeEffect: { crossFade: !0 },
                                speed: this.transitionSpeed,
                                autoplay: this.autoplayParams,
                                observer: !0,
                                observeParents: !0,
                                observeSlideChildren: !0,
                                loop: this.loop,
                                loopAdditionalSlides: 3,
                                grabCursor: this.grabCursor,
                                simulateTouch: this.grabCursor,
                                watchSlidesProgress: !0,
                                nested: this.nested,
                                autoHeight: this.autoheight,
                                breakpoints: {
                                    0: {
                                        slidesPerGroup: this.mobileSlidesPerGroup,
                                        slidesPerView: this.mobileSlidesPerView,
                                        spaceBetween: this.spaceBetweenSlidesMobile,
                                    },
                                    768: {
                                        slidesPerGroup: this.tabletSlidesPerGroup,
                                        slidesPerView: this.tabletSlidesPerView,
                                        spaceBetween: this.spaceBetweenSlidesTablet,
                                    },
                                    992: {
                                        slidesPerGroup: this.desktopSlidesPerGroup,
                                        slidesPerView: this.desktopSlidesPerView,
                                        spaceBetween: this.spaceBetweenSlidesDesktop,
                                    },
                                },
                                pagination: this.paginationParams,
                                scrollbar: this.scrollbarParams,
                                navigation: this.navigationParams,
                                on: {
                                    init: (e) => {
                                        if ((this.updateActiveTextItem(), this.loop)) {
                                            const t = document.createDocumentFragment(),
                                                i = e.slides.length,
                                                s = Math.ceil(10 / i);
                                            for (let i = 0; i < s; i++)
                                                e.slides.forEach((e) => {
                                                    t.appendChild(e.cloneNode(!0));
                                                });
                                            e.wrapperEl.appendChild(t), e.update(), (0, a.M)();
                                        }
                                        this.playVisibleSlideVideos();
                                    },
                                    transitionStart: () => {
                                        this.pauseAllVideos();
                                    },
                                    transitionEnd: () => {
                                        this.playVisibleSlideVideos();
                                    },
                                    slideChange: () => {
                                        this.updateActiveTextItem();
                                    },
                                },
                            })),
                            this.swiper.on("update", () => {
                                this.playVisibleSlideVideos();
                            }),
                            this.hasTextPagination)
                        ) {
                            const e = this.parentContainer.querySelectorAll(".slideshow-text-controls__item");
                            this.updateSlideVisibility(),
                                e.forEach((e) => {
                                    e.addEventListener("click", () => {
                                        const t = e.getAttribute("data-slide"),
                                            i = Array.from(this.swiper.slides).findIndex(
                                                (e) => e.getAttribute("data-slide") === t
                                            );
                                        -1 !== i && this.swiper.slideTo(i);
                                    });
                                });
                        }
                    }
                    disconnectedCallback() {
                        window.removeEventListener("resize", this.handleSliderDisplayLogic.bind(this)),
                            window.removeEventListener("resize", this.updateSlideVisibility.bind(this)),
                            window.removeEventListener("resize", this.checkSlidesPerView.bind(this)),
                            Shopify.designMode &&
                                (document.removeEventListener(
                                    "shopify:section:load",
                                    this.handleSliderDisplayLogic.bind(this)
                                ),
                                document.removeEventListener(
                                    "shopify:section:load",
                                    this.updateSlideVisibility.bind(this)
                                ),
                                document.removeEventListener(
                                    "shopify:section:load",
                                    this.checkSlidesPerView.bind(this)
                                )),
                            this.swiper && (this.swiper.destroy(!0, !0), (this.swiper = null));
                    }
                    checkSlidesPerView() {
                        const e = this.getCurrentBreakpoint(),
                            t = this.getSlidesPerView(e);
                        this.slideCount <= t ? this.destroySwiper() : this.handleSliderDisplayLogic();
                    }
                    getCurrentBreakpoint() {
                        return window.matchMedia("(min-width: 992px)").matches
                            ? "desktop"
                            : window.matchMedia("(min-width: 768px)").matches
                              ? "tablet"
                              : "mobile";
                    }
                    getSlidesPerView(e) {
                        switch (e) {
                            case "desktop":
                                return this.desktopSlidesPerView;
                            case "tablet":
                                return this.tabletSlidesPerView;
                            case "mobile":
                                return this.mobileSlidesPerView;
                            default:
                                return 1;
                        }
                    }
                    destroySwiper() {
                        this.swiper &&
                            (this.swiper.destroy(!0, !0),
                            (this.swiper = null),
                            this.parentContainer.classList.remove("slider-enabled"),
                            this.classList.add("swiper-prevent-content-shift"));
                    }
                }
                customElements.get("slider-component") || customElements.define("slider-component", r);
            },
            6072: function (e, t, i) {
                i.d(t, {
                    Ds: function () {
                        return a;
                    },
                    Q2: function () {
                        return s;
                    },
                    hO: function () {
                        return n;
                    },
                    zx: function () {
                        return o;
                    },
                });
                const s = function () {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
                            },
                        };
                    },
                    n = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const t = window.innerWidth - document.body.offsetWidth,
                            i = document.getElementById("nav-wrapper");
                        e
                            ? (document.body.classList.add("no-scroll"),
                              (document.body.style.paddingRight = t + "px"),
                              (i.style.paddingRight = t + "px"))
                            : (document.body.classList.remove("no-scroll"),
                              (document.body.style.paddingRight = "0px"),
                              (i.style.paddingRight = "0px"));
                    };
                function a(e, t) {
                    const i = this;
                    let s;
                    return function () {
                        for (var n = arguments.length, a = new Array(n), r = 0; r < n; r++) a[r] = arguments[r];
                        clearTimeout(s),
                            (s = setTimeout(function () {
                                return e.apply(i, a);
                            }, t));
                    };
                }
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        !(function (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            const i = document.getElementById("nav-wrapper"),
                                s = document.querySelector(".header").getAttribute("data-ux-position"),
                                n = e.getBoundingClientRect().top;
                            window.scrollTo({
                                top:
                                    "off" !== s
                                        ? n + window.scrollY - t + parseFloat(i.style.marginTop)
                                        : n + window.scrollY - t,
                                behavior: "smooth",
                            });
                        })(document.querySelector(t));
                    });
                });
                const r = {};
                function o(e) {
                    document.removeEventListener("focusin", r.focusin),
                        document.removeEventListener("focusout", r.focusout),
                        document.removeEventListener("keydown", r.keydown),
                        e && e.focus();
                }
            },
        },
        i = {};
    function s(e) {
        var n = i[e];
        if (void 0 !== n) return n.exports;
        var a = (i[e] = { exports: {} });
        return t[e].call(a.exports, a, a.exports, s), a.exports;
    }
    (s.m = t),
        (e = []),
        (s.O = function (t, i, n, a) {
            if (!i) {
                var r = 1 / 0;
                for (c = 0; c < e.length; c++) {
                    (i = e[c][0]), (n = e[c][1]), (a = e[c][2]);
                    for (var o = !0, l = 0; l < i.length; l++)
                        (!1 & a || r >= a) &&
                        Object.keys(s.O).every(function (e) {
                            return s.O[e](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((o = !1), a < r && (r = a));
                    if (o) {
                        e.splice(c--, 1);
                        var d = n();
                        void 0 !== d && (t = d);
                    }
                }
                return t;
            }
            a = a || 0;
            for (var c = e.length; c > 0 && e[c - 1][2] > a; c--) e[c] = e[c - 1];
            e[c] = [i, n, a];
        }),
        (s.d = function (e, t) {
            for (var i in t) s.o(t, i) && !s.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
        }),
        (s.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (s.j = 2547),
        (function () {
            var e = { 2547: 0, 7658: 0, 7954: 0, 3625: 0 };
            s.O.j = function (t) {
                return 0 === e[t];
            };
            var t = function (t, i) {
                    var n,
                        a,
                        r = i[0],
                        o = i[1],
                        l = i[2],
                        d = 0;
                    if (
                        r.some(function (t) {
                            return 0 !== e[t];
                        })
                    ) {
                        for (n in o) s.o(o, n) && (s.m[n] = o[n]);
                        if (l) var c = l(s);
                    }
                    for (t && t(i); d < r.length; d++) (a = r[d]), s.o(e, a) && e[a] && e[a][0](), (e[a] = 0);
                    return s.O(c);
                },
                i = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
            i.forEach(t.bind(null, 0)), (i.push = t.bind(null, i.push.bind(i)));
        })();
    var n = s.O(void 0, [1216], function () {
        return s(6999);
    });
    n = s.O(n);
})();